import { Link } from "react-router-dom";
import { Scale, Clock, LayoutDashboard, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Dedicated waiting screen for attorneys whose application is pending review.
export default function AttorneyPending() {
  const { user, logout } = useAuth();
  const status = user?.attorney_status;
  const rejected = status === "rejected";
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center" data-testid="attorney-pending">
      <div className={`inline-flex h-16 w-16 rounded-2xl items-center justify-center mb-5 ${rejected ? "bg-red-50" : "bg-amber-50"}`}>
        {rejected ? <Scale className="w-8 h-8 text-red-500" /> : <Clock className="w-8 h-8 text-amber-500" />}
      </div>
      <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-navy">
        {rejected ? "Application not approved" : "Attorney application under review"}
      </h1>
      <p className="text-slate-500 mt-2 max-w-md">
        {rejected
          ? "Your attorney application was not approved. Please contact support if you believe this is an error."
          : "Thanks for applying. Our team is reviewing your firm details. You'll be notified as soon as your account is approved, then you'll have full access to the Attorney Portal and Firm Command Center."}
      </p>
      {user?.firm_name && <p className="text-xs text-slate-400 mt-3">Firm: {user.firm_name}{user.bar_state ? ` · Bar ${user.bar_state}` : ""}</p>}
      <div className="mt-6 flex items-center gap-3">
        <Link to="/dashboard" data-testid="attorney-pending-dashboard" className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-white border border-slate-200 text-navy text-sm font-medium hover:bg-slate-50">
          <LayoutDashboard className="w-4 h-4" /> Go to dashboard
        </Link>
        <button onClick={logout} data-testid="attorney-pending-logout" className="flex items-center gap-2 px-5 py-2.5 rounded-full text-slate-500 text-sm font-medium hover:text-navy">
          <LogOut className="w-4 h-4" /> Log out
        </button>
      </div>
    </div>
  );
}
